/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { UtenteRuoloUfficioStorico } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce storico collegamenti tra Utenti Ruoli e Uffici
 * @summary Restituisce storico collegamenti tra Utenti Ruoli e Uffici
 */
export const getUtenteRuoloUfficioStorico = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<UtenteRuoloUfficioStorico[]>(
    {
      url: `/framework-cfg-utenti/utente-ruolo-ufficio-storico`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetUtenteRuoloUfficioStoricoQueryKey = () =>
  [`/framework-cfg-utenti/utente-ruolo-ufficio-storico`] as const;

export const getGetUtenteRuoloUfficioStoricoQueryOptions = <
  TData = Awaited<ReturnType<typeof getUtenteRuoloUfficioStorico>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUtenteRuoloUfficioStorico>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getUtenteRuoloUfficioStorico>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUtenteRuoloUfficioStoricoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUtenteRuoloUfficioStorico>>
  > = ({ signal }) => getUtenteRuoloUfficioStorico(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetUtenteRuoloUfficioStoricoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUtenteRuoloUfficioStorico>>
>;
export type GetUtenteRuoloUfficioStoricoQueryError = ErrorType<unknown>;

/**
 * @summary Restituisce storico collegamenti tra Utenti Ruoli e Uffici
 */
export const useGetUtenteRuoloUfficioStorico = <
  TData = Awaited<ReturnType<typeof getUtenteRuoloUfficioStorico>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getUtenteRuoloUfficioStorico>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetUtenteRuoloUfficioStoricoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
